const HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000
const RECENT_ACTIVITY_WINDOW_MS = 15 * 60 * 1000
const PING_ENDPOINT = '/api/ping-admin'
const ACTIVITY_EVENTS = ['pointerdown', 'keydown', 'scroll', 'touchstart']

let lastActivityAt = Date.now()
let heartbeatTimer = null

function registerActivity() {
  lastActivityAt = Date.now()
}

function hasRecentActivity() {
  return Date.now() - lastActivityAt <= RECENT_ACTIVITY_WINDOW_MS
}

function redirectToLoginIfSessionExpired(error) {
  const status = error && error.response ? error.response.status : null

  if (status === 401) {
    window.location.assign('/login')
  }
}

async function renewSessionWhenActive() {
  if (document.visibilityState !== 'visible' || !hasRecentActivity()) {
    return
  }

  try {
    await window.axios.get(PING_ENDPOINT, {
      headers: { Accept: 'application/json' }
    })
  } catch (error) {
    redirectToLoginIfSessionExpired(error)
  }
}

function handleVisibilityChange() {
  if (document.visibilityState !== 'visible') {
    return
  }

  registerActivity()
  renewSessionWhenActive()
}

export function startAdminSessionKeepAlive() {
  if (heartbeatTimer || !window.Laravel || !window.Laravel.user) {
    return
  }

  ACTIVITY_EVENTS.forEach((eventName) => {
    document.addEventListener(eventName, registerActivity, { passive: true })
  })

  document.addEventListener('visibilitychange', handleVisibilityChange)
  heartbeatTimer = window.setInterval(renewSessionWhenActive, HEARTBEAT_INTERVAL_MS)
}

